import React, { Component } from 'react';
import { Row, Col, Label , Collapse, Button } from "reactstrap";
import { formatNullableValue } from '../../../../utils/formatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {IconeSetaDescer, IconeSetaSubir, Baixar} from "../../../comum/components/Icones";

export default class NovoDirecionamentoCard extends Component {
    constructor(props) {
        super(props);
        this.controller = this.props.controller;

        this.renderFields = this.renderFields.bind(this)
    }

    renderFields(col) {
        if(col.dataField !== this.props.titulo && col.dataField !== this.props.subtitulo && col.text !== "Anexo"){
            if(col.typeButton) {
                return (
                    <div className="info bg-cinza">
                        <div className="valor">
                            <Button className="btn-com-bordas-cinza" onClick={() => col.buttonOnclick(this.props.data)}>
                                {col.typeButton}
                            </Button>
                        </div>
                    </div>
                )
            } else{
                return (
                    <div className="info bg-cinza">
                        <div className="titulo">{col.text}</div>
                        <div className="valor">
                            {formatNullableValue(this.props.data[col.dataField], this.props.data)}
                        </div>
                    </div>
                )
            }
        }else if(col.text === "Anexo"){
            if(this.props.data.Anexo){
                return (
                    <div className="info bg-cinza" onClick={() => col.buttonOnclick(this.props.data)}>
                        <div className="titulo">Axexo</div>
                        <div className={`valor`}>{ this.props.data.Anexo ? this.props.data.Anexo.name : "---" }</div>
                    </div>
                )
            } else {
                return(
                    <div className="info bg-cinza">
                        <div className="valor">
                            <Button className="btn-com-bordas-cinza" onClick={() => col.buttonOnclick(this.props.data)}>
                                Anexar
                            </Button>
                        </div>
                    </div>
                )
            }
        }
        return null
    }


    render() {
        return (
            <Col xs={12} md={6} lg={4} className="px-0">
                <div className={`card-navio`}>
                    <Row>

                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                                <Label className="subtitulo">{ this.props.data[this.props.subtitulo] }</Label>
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                            (col.dataField !== this.props.titulo) &&
                            (col.dataField !== this.props.subtitulo) &&
                            <Col xs={col.text === "Anexo" ? 12 : 6} className="px-0" key={x}>
                                {this.renderFields(col)}
                            </Col>
                        )}
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/components/NovoDirecionamentoCard.js